import { addAttribute } from "../../utils/otel";
import { EVENT_NAME, EVENT_NAMES, LOG_SEVERITIES, SESSION_RECORDING_END_TIME_UNIX_NANO, SESSION_RECORDING_EVENT_COUNT, SESSION_RECORDING_HAS_SNAPSHOT, SESSION_RECORDING_ID, SESSION_RECORDING_SEQ, } from "../../semantic-conventions";
import { addCommonAttributes } from "../../attributes";
import { toNanosTs } from "../../utils";
export function buildSessionRecordingLog(stream, chunk) {
    const attributes = [];
    addAttribute(attributes, EVENT_NAME, EVENT_NAMES.SESSION_RECORDING);
    addCommonAttributes(attributes);
    addAttribute(attributes, SESSION_RECORDING_ID, stream.recordingId);
    addAttribute(attributes, SESSION_RECORDING_SEQ, { intValue: String(chunk.seq) });
    addAttribute(attributes, SESSION_RECORDING_EVENT_COUNT, { intValue: String(chunk.eventCount) });
    addAttribute(attributes, SESSION_RECORDING_HAS_SNAPSHOT, chunk.hasSnapshot);
    addAttribute(attributes, SESSION_RECORDING_END_TIME_UNIX_NANO, { intValue: toNanosTs(chunk.endTime) });
    return {
        timeUnixNano: toNanosTs(chunk.startTime),
        severityNumber: LOG_SEVERITIES.INFO,
        severityText: "INFO",
        body: { stringValue: chunk.body },
        attributes,
        traceId: stream.traceId,
        spanId: stream.spanId,
    };
}
